<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'home'" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="ac mt40">
          <strong class="titH2">
            그동안 웰몰을
            <br />
            이용해주셔서 감사합니다.
          </strong>
          <p class="txtM mt10">탈퇴하시기 전에 아래 내용을 확인해주세요!</p>
        </section>

        <section class="hr">
          <div class="formArea mt0">
            <span class="label mt0">안내사항</span>
            <div class="boxMsg jqScroll vertical" v-html="webView"></div>
            <span class="singleIpt mt20">
              <input type="checkbox" class="ipt notDel uiAct" name="jqscroll_chk" id="jqscroll_chk" v-model="term1" />
              <label for="jqscroll_chk">위의 내용을 확인하였습니다.</label>
            </span>
            <span class="label">탈퇴사유</span>
            <select class="ipt" title="탈퇴사유 선택" v-model="withdrawCode">
              <option value="" selected="selected">선택해주세요</option>
              <option v-for="(option, key) in withdrawCodeList" v-bind:value="option.code" v-bind:key="key">
                {{ option.codeName }}
              </option>
            </select>
            <textarea class="ipt" title="글내용 입력" placeholder="내용을 입력하세요." v-model="withdrawReason"></textarea>
            <span class="label">기타 개선사항이나 의견이 있으면 남겨주세요.</span>
            <textarea class="ipt" title="글내용 입력" placeholder="내용을 입력하세요." v-model="withdrawReasonEtc"></textarea>
          </div>

          <!-- btnArea (s) -->
          <div class="btnArea">
            <a href="javascript:;" class="btn_s" @click="PutWithdrawal">회원탈퇴</a>
          </div>
          <!-- btnArea (e) -->
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import MessagePop from '@/components/popup/MessagePop';
import { isEmpty } from '@/common/common.function';

export default {
  name: 'withdrawal',
  components: { MessagePop },
  mounted() {
    this.userInfo = JwtService.getUserInfo();
    this.webViewInit();
    this.optionInit();
  },
  data: function() {
    return {
      headerTitle: '회원탈퇴',
      userInfo: null,
      withdrawCodeList: [],
      withdrawalState: false,

      term1: false,

      msg: '',
      messagePop: false,

      withdrawCode: '',
      withdrawReason: '',
      withdrawReasonEtc: '',

      webView: '',
    };
  },
  watch: {},
  computed: {},
  methods: {
    optionInit: function() {
      ApiService.service('GET', '/common/code/SPWD')
        .then(({ data }) => {
          console.log(data.result);
          this.withdrawCodeList = data.result[0].codeList;
          console.log(this.withdrawCodeList);
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    //회원탈퇴
    PutWithdrawal: function() {
      if (!this.term1) {
        this.msg = '유의사항을 확인해주세요.';
        this.messagePop = true;
        return false;
      }
      if (isEmpty(this.withdrawCode)) {
        this.msg = '탈퇴사유를 선택해주세요.';
        this.messagePop = true;
        return false;
      }
      this.$refs.header.loadingStart();
      ApiService.service('PUT', 'user/auth/account/withdraw', {
        request: {
          userId: this.userInfo.userId,
          withdrawCode: this.withdrawCode,
          withdrawReason: this.withdrawReason,
          withdrawReasonEtc: this.withdrawReasonEtc,
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.msg = '회원탈퇴가 완료되었습니다.<br>웰몰을 이용해주셔서<br>감사합니다.';
            this.messagePop = true;
            this.withdrawalState = true;
          } else {
            this.msg = '회원탈퇴에 실패하였습니다.';
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        })
        .finally(() => {
          this.$refs.header.loadingEnd();
        });
    },
    async webViewInit() {
      let webViews = await ApiService.service('GET', 'common/webView/WB000004');
      console.log(webViews);
      let webView = await ApiService.service('GET', webViews.data.result[0].filePath).catch(err => {});
      this.webView = webView.data;
    },
    close() {
      console.log(this.user);
      this.messagePop = false;
      this.webViewPop = false;

      if (this.withdrawalState) {
        JwtService.logout();
        this.$router.push({ name: 'main' });
      }
    },
  },
  destroyed() {},
};
</script>
